<template>
  <div class="">
    <div class="max-w-7xl mx-auto my-5">
      <div class="px-1 md:px-20">
        <div class="mt-8 pb-16 sm:mt-12 sm:pb-20 lg:pb-28">
          <div class="relative">
            <div class="absolute inset-0 h-1/2 bg-gray-100"></div>
            <div class="relative max-w-screen-xl mx-auto px-4 sm:px-6 lg:px-8">
              <div
                class="max-w-lg mx-auto rounded-lg shadow-lg overflow-hidden lg:max-w-none lg:flex"
              >
                <div class="bg-white px-6 py-8 lg:p-12">
                  <h3
                    class="text-2xl leading-8 font-extrabold text-gray-900 sm:text-3xl sm:leading-9"
                  >
                    Team Inbox
                  </h3>
                  <p class="mt-6 text-base leading-6 text-gray-500">
                    Engage with your customers on their favorite messaging app
                    and sell more as a team.
                  </p>
                  <div class="mt-8">
                    <div class="flex items-center">
                      <h4
                        class="flex-shrink-0 pr-4 bg-white text-sm leading-5 tracking-wider font-semibold uppercase"
                      >
                        What's included
                      </h4>
                      <div class="flex-1 border-t-2 border-gray-200"></div>
                    </div>
                    <ul
                      class="mt-8 lg:grid lg:grid-cols-2 lg:gap-x-8 lg:gap-y-5"
                    >
                      <li class="flex items-start lg:col-span-1">
                        <div class="flex-shrink-0">
                          <!-- Heroicon name: check-circle -->
                          <svg
                            class="h-5 w-5 text-green-400"
                            viewBox="0 0 20 20"
                            fill="currentColor"
                          >
                            <path
                              fill-rule="evenodd"
                              d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                              clip-rule="evenodd"
                            />
                          </svg>
                        </div>
                        <p class="ml-3 text-sm leading-5 text-gray-700">
                          1000 incoming messages for Team Inbox
                        </p>
                      </li>
                      <li class="mt-5 flex items-start lg:col-span-1 lg:mt-0">
                        <div class="flex-shrink-0">
                          <!-- Heroicon name: check-circle -->
                          <svg
                            class="h-5 w-5 text-green-400"
                            viewBox="0 0 20 20"
                            fill="currentColor"
                          >
                            <path
                              fill-rule="evenodd"
                              d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                              clip-rule="evenodd"
                            />
                          </svg>
                        </div>
                        <p class="ml-3 text-sm leading-5 text-gray-700">
                          Free Whatsapp API approval
                        </p>
                      </li>
                      <li class="mt-5 flex items-start lg:col-span-1 lg:mt-0">
                        <div class="flex-shrink-0">
                          <!-- Heroicon name: check-circle -->
                          <svg
                            class="h-5 w-5 text-green-400"
                            viewBox="0 0 20 20"
                            fill="currentColor"
                          >
                            <path
                              fill-rule="evenodd"
                              d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                              clip-rule="evenodd"
                            />
                          </svg>
                        </div>
                        <p class="ml-3 text-sm leading-5 text-gray-700">
                          Custom automated message templates
                        </p>
                      </li>
                      <li class="mt-5 flex items-start lg:col-span-1 lg:mt-0">
                        <div class="flex-shrink-0">
                          <!-- Heroicon name: check-circle -->
                          <svg
                            class="h-5 w-5 text-green-400"
                            viewBox="0 0 20 20"
                            fill="currentColor"
                          >
                            <path
                              fill-rule="evenodd"
                              d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                              clip-rule="evenodd"
                            />
                          </svg>
                        </div>
                        <p class="ml-3 text-sm leading-5 text-gray-700">
                          Priority customer support
                        </p>
                      </li>
                      <li class="mt-5 flex items-start lg:col-span-1 lg:mt-0">
                        <div class="flex-shrink-0">
                          <!-- Heroicon name: check-circle -->
                          <svg
                            class="h-5 w-5 text-green-400"
                            viewBox="0 0 20 20"
                            fill="currentColor"
                          >
                            <path
                              fill-rule="evenodd"
                              d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                              clip-rule="evenodd"
                            />
                          </svg>
                        </div>
                        <p class="ml-3 text-sm leading-5 text-gray-700">
                          Early access to our new features
                        </p>
                      </li>
                      <li class="mt-5 flex items-start lg:col-span-1 lg:mt-0">
                        <div class="flex-shrink-0">
                          <!-- Heroicon name: check-circle -->
                          <svg
                            class="h-5 w-5 text-green-400"
                            viewBox="0 0 20 20"
                            fill="currentColor"
                          >
                            <path
                              fill-rule="evenodd"
                              d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                              clip-rule="evenodd"
                            />
                          </svg>
                        </div>
                        <p class="ml-3 text-sm leading-5 text-gray-700">
                          $10 for 5000 session messages after 1000 messages
                        </p>
                      </li>
                    </ul>
                  </div>
                </div>
                <div
                  class="py-8 px-6 text-center bg-gray-50 lg:flex-shrink-0 lg:flex lg:flex-col lg:justify-center lg:p-12"
                >
                  <p
                    v-if="showUpgrade"
                    class="text-lg leading-6 font-medium text-gray-900"
                  >
                    Simple pricing
                  </p>
                  <div
                    class="mt-4 flex items-center justify-center text-5xl leading-none font-extrabold text-gray-900"
                    v-if="showUpgrade"
                  >
                    <span> $29 </span>
                    <span
                      class="ml-3 text-xl leading-7 font-medium text-gray-500"
                    >
                      USD
                    </span>
                  </div>

                  <div class="mt-6">
                    <div class="rounded-md shadow">
                      <a
                        v-if="showUpgrade"
                        class="flex items-center justify-center px-5 py-3 border border-transparent text-base leading-6 font-medium rounded-md text-white bg-gray-900 hover:bg-gray-800 focus:outline-none focus:shadow-outline transition duration-150 ease-in-out cursor-pointer"
                        @click="choosePlan('advanced')"
                      >
                        {{ getTrialButtonContent("advanced") }}
                      </a>
                      <a
                        v-if="showRequestAccess"
                        class="flex items-center justify-center px-5 py-3 border border-transparent text-base leading-6 font-medium rounded-md text-white bg-gray-900 hover:bg-gray-800 focus:outline-none focus:shadow-outline transition duration-150 ease-in-out cursor-pointer"
                        @click="connectOwnNumber"
                      >
                        Get Whatsapp API Approval
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            class="max-w-screen-xl mx-auto py-12 px-4 sm:py-16 sm:px-6 lg:px-8"
          >
            <div class="Polaris-LegacyCard">
              <div class="Polaris-LegacyCard__Header">
                <h2 class="Polaris-Text--root Polaris-Text--headingLg">
                  Frequently asked questions
                </h2>
              </div>
              <div class="Polaris-LegacyCard__Section">
                <AccordianItem
                  v-for="(faq, index) of faqs"
                  :key="index"
                  :title="faq.title"
                  :content="faq.content"
                />
              </div>
            </div>
          </div>
          <div>
            <div
              class="max-w-screen-xl mx-auto py-12 px-4 sm:py-16 sm:px-6 lg:px-8"
            >
              <div class="Polaris-LegacyCard">
                <div class="Polaris-LegacyCard__Header">
                  <h2 class="Polaris-Text--root Polaris-Text--headingLg">
                    How it looks in mobile
                  </h2>
                </div>
                <div class="Polaris-LegacyCard__Section">
                  <div class="grid grid-cols-2 gap-4">
                    <img
                      src="https://instaimages.carthike.com/teaminbox/screely-1740120283510.png"
                      alt="Team Inbox Screenshot"
                      class="rounded-lg shadow-lg w-full h-auto"
                    />
                    <img
                      src="https://instaimages.carthike.com/teaminbox/screely-1740120618172.png"
                      alt="Team Inbox Screenshot"
                      class="rounded-lg shadow-lg w-full h-auto"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <OwnNumberForm
        v-if="showOwnNumberForm"
        @close="showOwnNumberForm = false"
      />
    </div>
  </div>
</template>

<script>
import { differenceInDays } from "date-fns";

import OwnNumberForm from "../../components/Forms/OwnNumberForm.vue";
import AccordianItem from "../../components/Common/AccordianItem";
import crispNudgeMixin from "../../Mixins/crispNudgeMixin";

export default {
  name: "InboxHome",
  mixins: [crispNudgeMixin],
  components: {
    AccordianItem,
    OwnNumberForm
  },
  data() {
    return {
      showUpgrade: false,
      showOwnNumberForm: false,
      showRequestAccess: false,
      faqs: [
        {
          title: "Will I be charged for failed messages?",
          content:
            "No, if that’s not a WhatsApp number or if we couldn’t deliver a message we wouldn’t count that message."
        },
        {
          title: "Will the automated messages go from my number?",
          content:
            "Yes with our advanced plan, Your automated messages will be sent from your number and you can also reply to the messages you receive in that number. On Vip Plan messages will be sent from our business number"
        },
        {
          title: "Can I send WhatsApp messages to everybody?",
          content:
            "You can only send it to people who have opted in via checkout."
        },
        {
          title: "What are session messages?",
          content:
            "WhatsApp Session messages are any messages sent and received in response to a user-initiated message to number. A messaging session starts when a user sends your application a message and lasts for 24 hours from the most recently received message."
        },
        {
          title: "What If I want to send a message after 24 Hours?",
          content:
            "You could either wait for the customer to send a message or You could send a template message to initiate the conversation again."
        },
        {
          title: "How will I get Charged?",
          content:
            "Our Advanced plan includes 1000 session messages(incoming & outgoing), Once you have reached the limit we will charge $10 for the next 5000 messages"
        },
        {
          title: "What are the team inbox charges?",

          content: `Team inbox is part of our advanced plan and only needed for pure API numbers. After first 1000 chat messages (both incoming and outgoing) it's $10 for 5000 messages. New conversation or template messages which are sent after 24 hr window has a <a href="https://docs.google.com/spreadsheets/d/1g0BZDH4dhmaYmncEiTof-9iR1qnxf0Tp/edit?usp=sharing&ouid=107245128238572849936&rtpof=true&sd=true" target="blank" class="text-blue-700 text-sm underline hover:text-blue-900">per message cost</a> `
        }
      ]
    };
  },
  created() {
    const store = this.$store.getters.getStore;
    if (store.hasAccessToTeamInbox) {
      this.$store.dispatch("getTeamInboxToken").then((response) => {
        this.apiKey = response.token;
        if (store.id === "68b960087f41330651d53b91") {
          window.open(
            `https://oudluxuryteaminbox.carthike.com/#/teaminbox/${this.apiKey}`,
            "_blank"
          );
        } else if (store.id === "69f1ac2123f9462dbc41e0c3") {
          window.open(
            `${process.env.VUE_APP_TEAM_INBOX_URL}#/teaminbox/${this.apiKey}`,
            "_self"
          );
          return;
        } else {
          window.open(
            `${process.env.VUE_APP_TEAM_INBOX_URL}#/teaminbox/${this.apiKey}`,
            "_blank"
          );
        }
      });

      this.$router.push({ name: "InboxAlert" });
      return;
    }
    if (store.plan === "advanced") {
      // this.$router.push({ name: "ApplyNumber" });
      // this.openCrisp();
      this.showRequestAccess = true;
      this.showTeamInboxAccessNudge();
      return;
    }

    if (store.plan !== "advanced") {
      this.showUpgrade = true;
    }
  },
  methods: {
    showTeamInboxAccessNudge() {
      this.showCrispNudge({
        key: "team_inbox_access_gating",
        text: "Need Team Inbox access? We can guide you to the fastest activation path.",
        cooldownMs: 30 * 60 * 1000,
        scopeToRoute: true
      });
    },
    openCrisp() {
      $crisp.push(["do", "chat:open"]); // eslint-disable-line
      // eslint-disable-next-line
      $crisp.push([
        "do",
        "message:send",
        ["text", `Need access to use team inbox`]
      ]);
    },
    connectOwnNumber() {
      this.showOwnNumberForm = true;
    },

    gotoWhatsappApplying() {
      this.$router.push({
        name: "ApplyNumber",
        query: { feature: "team_inbox" }
      });
    },
    choosePlan(plan) {
      this.$store
        .dispatch("selectPlan", { requestParams: { plan } })
        .then((response) => {
          if (response.confirmationUrl) {
            if (window.top) {
              window.top.location = response.confirmationUrl;
            } else {
              window.location.href = response.confirmationUrl;
            }
            return;
          }
          if (response.ok) {
            this.$router.push({ name: "Home" });
          }
        });
    },
    getTrialButtonContent(plan) {
      const trialDetails = this.$store.getters.getTrailDetails;

      if (trialDetails && trialDetails[plan]) {
        if (plan === "vip" && trialDetails.vipTrialStartedAt) {
          const startDate = new Date(trialDetails.vipTrialStartedAt * 1000);
          const daysLeft = 7 - differenceInDays(new Date(), startDate);
          if (daysLeft > 0) {
            return `Resume Trial`;
          }
          return "Upgrade";
        }
        if (plan === "advanced" && trialDetails.advancedTrialStartedAt) {
          const startDate = new Date(
            trialDetails.advancedTrialStartedAt * 1000
          );
          const daysLeft = 7 - differenceInDays(new Date(), startDate);
          if (daysLeft > 0) {
            return `Resume Trial`;
          }
          return "Upgrade";
        }

        return "Upgrade";
      }
      return "Start 7 day Trial";
    }
  }
};
</script>

<style lang="scss" scoped></style>
